module.exports = __webpack_public_path__ + "assets/media/website_preview.819424de.svg";